import { useContext, useEffect, useState } from "react";
import { EggCollectedDialog } from "./EggCollectedDialog";
import { loadChallenges } from "../../apiCalls/challenges/api_v1_challenges";
import {
  EGG_REWARD_EVENT,
  EGG_REWARD_CLOSED_EVENT,
  rememberClaimedRewards,
} from "../../utils/eggReward";
import { AuthContext } from "../../apiCalls/jwt/AuthContext";

export function EggRewardHost() {
  const { auth } = useContext(AuthContext);
  const [queue, setQueue] = useState([]);

  useEffect(() => {
    // Wait for token — calling /challenges before auth causes 401 + retry duplicates.
    const token = auth?.accessToken || sessionStorage.getItem("accessToken");
    if (!token) return undefined;

    let cancelled = false;
    // Use cache when fresh so Play/Home do not each force a second /challenges.
    loadChallenges()
      .then((loaded) => {
        if (!cancelled) rememberClaimedRewards(loaded?.tasks);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, [auth?.accessToken]);

  useEffect(() => {
    const onReward = (event) => {
      const detail = event?.detail;
      const rewardEggs = Math.max(0, Number(detail?.rewardEggs) || 0);
      if (!rewardEggs) return;
      setQueue((prev) => [
        ...prev,
        {
          title: detail?.title ? String(detail.title) : "",
          rewardEggs,
          taskKey: detail?.taskKey ? String(detail.taskKey) : "",
          source: detail?.source ? String(detail.source) : "",
        },
      ]);
    };

    window.addEventListener(EGG_REWARD_EVENT, onReward);
    return () => window.removeEventListener(EGG_REWARD_EVENT, onReward);
  }, []);

  const current = queue[0] || null;

  const handleClose = () => {
    const closed = queue[0] || null;
    setQueue((prev) => prev.slice(1));
    if (closed && typeof window !== "undefined") {
      window.dispatchEvent(
        new CustomEvent(EGG_REWARD_CLOSED_EVENT, { detail: closed }),
      );
    }
  };

  return (
    <EggCollectedDialog
      open={Boolean(current)}
      title={current?.title || ""}
      rewardEggs={current?.rewardEggs || 0}
      onClose={handleClose}
    />
  );
}
